import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

import { Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading } from "capitalrx-components-2.0/lib/typography";

import { useNavigateSearch } from "@/premium/hooks";
import { ThemedButton } from "@/premium/themedComponents";
import { ANALYTIC_EVENTS, logEvent } from "@/utils/analytics";

const translationPath = "PLAN_DETAILS.medicarePrescriptionPaymentPlanPanel";

export const MedicarePrescriptionPaymentPlanPanel = () => {
  const { t: translate } = useTranslation();
  const [searchParams] = useSearchParams();
  const enrollmentPlanId = searchParams.get("enrollmentPlan");
  const navigate = useNavigateSearch();

  const sendToM3P = useCallback(() => {
    logEvent(ANALYTIC_EVENTS.M3P);
    navigate("/plan/medicare-prescription-payment-plan", {
      enrollmentPlan: enrollmentPlanId,
    });
  }, [enrollmentPlanId, navigate]);

  return (
    <Panel>
      <Stack>
        <Heading>{translate(`${translationPath}.medicarePrescriptionPaymentPlan`)}</Heading>
        <Body>{translate(`${translationPath}.programInfo`)}</Body>
        <Shelf>
          <ThemedButton onClick={sendToM3P}>{translate(`${translationPath}.viewProgramInfo`)}</ThemedButton>
          <Shelf.Spacer />
        </Shelf>
      </Stack>
    </Panel>
  );
};
